export default [
  { label: 'Template #1', value: 'SignatureTemplate1' }
]
